import { connect } from "react-redux";
import TicketDetails from "./ticketDetails";
import { bindActionCreators } from "redux";
import {
  fetchPmTicket,
  fetchPmTicketDetails,
  postUpdatePMStatus,
  postRemarks,
  fetchPmTicketStatus,
} from "services/redux/maintenance/pmTicket/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  pmTicket: state.pmTicketReducer.pmTicket,
  pmTicketDetails: state.pmTicketReducer.pmTicketDetails,
  pmTicketStatus: state.pmTicketReducer.pmTicketStatus
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmTicket,
      fetchPmTicketDetails,
      postUpdatePMStatus,
      documentUploadUrl,
      postRemarks,
      fetchPmTicketStatus,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TicketDetails);
